export function ExclamationMarkOutlineRedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_835_14175)">
        <path
          d="M5.4 7.80006H6.6V9.00006H5.4V7.80006ZM5.4 3.00006H6.6V6.60006H5.4V3.00006ZM5.994 6.10352e-05C2.682 6.10352e-05 0 2.68806 0 6.00006C0 9.31206 2.682 12.0001 5.994 12.0001C9.312 12.0001 12 9.31206 12 6.00006C12 2.68806 9.312 6.10352e-05 5.994 6.10352e-05ZM6 10.8001C3.348 10.8001 1.2 8.65206 1.2 6.00006C1.2 3.34806 3.348 1.20006 6 1.20006C8.652 1.20006 10.8 3.34806 10.8 6.00006C10.8 8.65206 8.652 10.8001 6 10.8001Z"
          fill="#EF4444"
        />
      </g>
      <defs>
        <clipPath id="clip0_835_14175">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
